import { Toaster } from 'react-hot-toast'
import { Link, Route, Routes } from 'react-router-dom'
import Footer from './components/Footer'
import Header from './components/Header'
import AbiHelper from './pages/AbiHelper'
import BigNumberHelpers from './pages/BigNumberHelpers'
import Debug from './pages/Debug'
import Home from './pages/Home'
import Multicall from './pages/Multicall'
import Providers from './providers'

function App() {
    return (
        <Providers>
            <div>
                <Toaster position="bottom-left" />
            </div>
            <Header />
            <Routes>
                <Route path="/" element={<Home />} />
                <Route path="/abi" element={<AbiHelper />} />
                <Route path="/debug" element={<Debug />} />
                <Route path="/multicall" element={<Multicall />} />
            </Routes>
            <Footer />
        </Providers>
    )
}

export default App
